export const InnodomDateFormats = {
  date: "YYYY-MM-DD",
  datetime: "YYYY-MM-DD HH:mm:ss",
  time: "HH:mm:ss",
};

export const WorkbenchDateFormats = {
  allSupported: [
    "MMM D YYYY",
    "MMM D, YYYY",
    "MMMM D YYYY",
    "MMMM D, YYYY",
    "MM-DD-YYYY",
    "DD-MM-YYYY",
  ],
  date: "MMM D, YYYY",
  datetime: "MMM D, YYYY \\a\\t hh:mm A",
  time: "hh:mm A",
};
